import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import dayjs from "dayjs";

const useStyles = makeStyles({
  card: {
    marginBottom: 12,
    border: "1px solid #e0e0e0",
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
  },
  cardContent: {
    paddingBottom: 8,
  },
  header: {
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  assessmentName: {
    fontWeight: 600,
    fontSize: 16,
    color: "#333",
  },
  infoGrid: {
    marginTop: 8,
  },
  label: {
    fontSize: 12,
    color: "#666",
    marginBottom: 4,
  },
  value: {
    fontWeight: 500,
    fontSize: 14,
  },
  cardActions: {
    padding: "8px 16px",
    paddingTop: 0,
  },
  pendingStatus: {
    fontWeight: 900,
    color: "#c9423a",
    border: "1px dashed #c9423a",
    fontSize: 13,
    padding: "6px 12px",
    borderRadius: 20,
    textAlign: "center",
    display: "inline-block",
  },
});

interface AssignmentCardProps { assignment: { accessor?: React.ReactNode; completed?: boolean; completed_date?: string; date?: string; name?: React.ReactNode }; icon: React.ElementType; color?: string; }

export default function AssignmentCard({ assignment, icon, color }: AssignmentCardProps): React.ReactElement {
  const classes = useStyles();

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.cardContent}>
        <div className={classes.header}>
          <SvgIcon
            component={icon}
            style={{
              fontSize: 32,
              color: color,
            }}
          />
          <Typography className={classes.assessmentName}>
            {assignment.name}
          </Typography>
        </div>

        <Grid container spacing={2} className={classes.infoGrid}>
          <Grid item xs={6}>
            <Typography className={classes.label}>Assigned Date</Typography>
            <Typography className={classes.value}>
              {dayjs(assignment.date).format("DD/MM/YYYY")}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography className={classes.label}>Completed Date</Typography>
            <Typography className={classes.value}>
              {assignment.completed
                ? dayjs(assignment.completed_date).format("DD/MM/YYYY")
                : "-"}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>

      <CardActions className={classes.cardActions}>
        {assignment.completed ? (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() =>
              window.open(
                `https://learn.elitefeats.com.au/report/${assignment.accessor}`,
                "_blank"
              )
            }
          >
            View Report
          </Button>
        ) : (
          <div style={{ width: "100%", textAlign: "center", padding: "8px 0" }}>
            <Typography className={classes.pendingStatus} component="span">
              Pending
            </Typography>
          </div>
        )}
      </CardActions>
    </Card>
  );
}
